import * as Slider from '@radix-ui/react-slider';
import type React from 'react';
import { SLIDER_CONFIG } from '../constants';

interface SliderTrackProps {
  startMinutes: number;
  endMinutes: number;
  minMinutes: number;
  maxMinutes: number;
  onValueChange: (values: number[]) => void;
}

const SliderTrack: React.FC<SliderTrackProps> = ({ startMinutes, endMinutes, minMinutes, maxMinutes, onValueChange }) => {
  return (
    <Slider.Root
      className='flex w-full touch-none select-none items-center'
      value={[startMinutes, endMinutes]}
      onValueChange={onValueChange}
      min={minMinutes}
      max={maxMinutes}
      step={SLIDER_CONFIG.STEP}
    >
      <Slider.Track className={`relative ${SLIDER_CONFIG.TRACK_HEIGHT} w-full grow overflow-hidden rounded-full bg-gray-5`}>
        <Slider.Range className='absolute h-full bg-primary transition-all duration-200 ease-out' />
      </Slider.Track>

      {/* Start thumb */}
      <Slider.Thumb
        className={`block ${SLIDER_CONFIG.THUMB_SIZE} -translate-x-[7px] rounded-full border-2 border-primary bg-white shadow-md transition-all duration-200 hover:scale-110 focus:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50`}
      />

      {/* End thumb */}
      <Slider.Thumb
        className={`block ${SLIDER_CONFIG.THUMB_SIZE} translate-x-[7px] rounded-full border-2 border-primary bg-white shadow-md transition-all duration-200 hover:scale-110 focus:scale-110 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50`}
      />
    </Slider.Root>
  );
};

export default SliderTrack;
